import type { UseWebhookSubscriptionsParams } from "./types";

export const webhookSubscriptionKeys = {
  all: ["webhookSubscriptions"] as const,
  lists: () => [...webhookSubscriptionKeys.all, "list"] as const,
  list: (params: UseWebhookSubscriptionsParams) =>
    [...webhookSubscriptionKeys.lists(), params] as const,
  details: () => [...webhookSubscriptionKeys.all, "detail"] as const,
  detail: (id?: string | null, integrationId?: string | null) =>
    [...webhookSubscriptionKeys.details(), id, integrationId] as const,
};
